import { BLACKOUT_SCOPES } from "helpers/blackouts"

/**
 * ⚠️ TEMPORARY — delete this file, and the `hasFailed` fallback in `useReplaceResources`, the day
 * `GET /guide/blackouts/:id/replacements` ships (backend item 13).
 *
 * The sheet is built and wired, but the endpoint does not exist yet, so against a real API it can
 * only ever render its "could not load" state. This stands in for the response so the flow can be
 * reviewed and demoed. It is used *only* when the request fails, so the moment the endpoint
 * answers, real data takes over with no other change.
 */
export const IS_MOCK_REPLACEMENTS_ENABLED = true

const MOCK_CREW = {
  bookings: [
    {
      id: "7001",
      uuid: "u-7001",
      booking_id: "DS-10241",
      trip_title: "Fishing Hunt",
      start_date: "2026-09-09",
      start_time: "8:00 AM",
      end_time: "12:00 PM",
      resource: { id: "218", label: "Monika Doe", category: "Captain" }
    },
    {
      id: "7002",
      uuid: "u-7002",
      booking_id: "DS-10242",
      trip_title: "Fishing Hunt 2",
      start_date: "2026-09-09",
      start_time: "1:00 PM",
      end_time: "5:00 PM",
      resource: { id: "347", label: "John Doe", category: "Mate" }
    },
    {
      id: "7003",
      uuid: "u-7003",
      booking_id: "DS-10251",
      trip_title: "Sunset Scalloping",
      start_date: "2026-09-10",
      start_time: "6:00 PM",
      end_time: "9:00 PM",
      resource: { id: "218", label: "Monika Doe", category: "Captain" }
    }
  ],
  candidates: [
    { id: "901", label: "Alex Rivera", category: "Captain", is_available: true },
    { id: "902", label: "Dana Whitfield", category: "Mate", is_available: true },
    { id: "903", label: "Sam Okafor", category: "Deckhand", is_available: true },
    // Filtered out of the pickers — kept so the "unavailable candidate" case is visible too.
    { id: "904", label: "Priya Nair", category: "Captain", is_available: false, unavailable_reason: "Already booked" }
  ]
}

const MOCK_EQUIPMENT = {
  bookings: [
    {
      id: "8001",
      uuid: "u-8001",
      booking_id: "DS-10488",
      trip_title: "Sample Exp 1",
      start_date: "2026-09-28",
      start_time: "7:00 AM",
      end_time: "11:00 AM",
      resource: { id: "1235", label: "MBoat 1 - Asset #0001", category: "Seaboat" }
    },
    {
      id: "8002",
      uuid: "u-8002",
      booking_id: "DS-10490",
      trip_title: "Fishing multiday trip",
      start_date: "2026-09-29",
      start_time: null,
      end_time: null,
      resource: { id: "1235", label: "MBoat 1 - Asset #0001", category: "Seaboat" }
    }
  ],
  candidates: [
    { id: "1236", label: "MBoat 2 - Asset #0001", category: "Seaboat", is_available: true },
    { id: "1240", label: "MBoat 2 - Asset #0002", category: "Seaboat", is_available: true },
    { id: "1223", label: "SpeedBoat 1 - Asset #0009", category: "Boat", is_available: true },
    { id: "1212", label: "Boat - Asset #0011", category: "Boat", is_available: false, unavailable_reason: "Out of service" }
  ]
}

export const getMockReplacements = (scope) => (scope === BLACKOUT_SCOPES.EQUIPMENT ? MOCK_EQUIPMENT : MOCK_CREW)
